import { SplashScreen } from '@ws/shared/components';

import { TextatorLogo } from '../TextatorLogo';

export function TextatorSplashScreen() {
  return <SplashScreen logo={<TextatorLogo />} />;
}
